<template>
  <section id="unfinished-orders">
    <b-overlay :show="showContent" spinner-variant="primary" variant="transparent" blur="3px" rounded="sm">
      <b-card-actions title="Filters" action-collapse>
        <b-row>
          <b-col>
            <b-form-group label="Selected Hub">
              <v-select label="name" :options="hubs" v-model="selectedHub" @input="changeSelectedHub" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-actions>
      <b-card no-body>
        <b-table striped hover responsive class="position-relative" :current-page="unfinishedOrdersTable.currentPage"
          :items="unfinishedOrdersTable.items" :fields="unfinishedOrdersTable.fields"
          :sort-by.sync="unfinishedOrdersTable.sortBy" :sort-desc.sync="unfinishedOrdersTable.sortDesc"
          :sort-direction="unfinishedOrdersTable.sortDirection" :filter="unfinishedOrdersTable.filter"
          :filter-included-fields="unfinishedOrdersTable.filterOn">
          <template #cell(distributor_name)="data">
            <b-badge variant="light-primary">
              {{ data.value }}
            </b-badge>
          </template>
        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
          <!-- pagination -->
          <div>
            <b-pagination v-model="unfinishedOrdersTable.currentPage" :total-rows="unfinishedOrdersTable.totalRows"
              first-number last-number prev-class="prev-item" next-class="next-item" class="mb-0"
              @change="handleUnfinishedOrdersPageChange">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-card>
    </b-overlay>
  </section>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BPagination,
  BOverlay,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
} from "bootstrap-vue"
import vSelect from "vue-select"
import axios from "axios"

import BCardActions from '@core/components/b-card-actions/BCardActions.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BPagination,
    BOverlay,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BCardActions,
  },
  data() {
    return {
      showContent: true,
      queryParams: {},
      hubs: [],
      selectedHub: null,
      unfinishedOrdersTable: {
        totalRows: 1,
        currentPage: 1,
        sortBy: "created_at",
        sortDesc: true,
        sortDirection: "desc",
        filter: null,
        filterOn: [],
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          { key: "number", label: "Order Number", sortable: true },
          { key: "full_name", label: "Customer Name", sortable: true },
          { key: "email", label: "Email", sortable: true },
          { key: "phone", label: "Phone", sortable: true },
          { key: "state", label: "Order State", sortable: true },
          { key: "payment_state", label: "Payment State", sortable: true },
          { key: "shipment_state", label: "Shipment State", sortable: true },
          {
            key: "total",
            label: "Total",
            sortable: true,
            formatter: value => `€${parseFloat(value).toFixed(2)}`
          },
          { key: "item_total", label: "Item Total", sortable: true },
          { key: "adjustment_total", label: "Adjustment", sortable: true },
          { key: "payment_total", label: "Payment Total", sortable: true },
          { key: "item_count", label: "Items", sortable: true },
          { key: "distributor_name", label: "hub", sortable: true },
          {
            key: "ready_to_ship",
            label: "Ready to Ship",
            sortable: true,
            formatter: value => value ? "Yes" : "No"
          },
          {
            key: "ready_to_capture",
            label: "Ready to Capture",
            sortable: true,
            formatter: value => value ? "Yes" : "No"
          },
          {
            key: "completed_at",
            label: "Completed At",
            sortable: true,
            formatter: value => {
              if (value) {
                let new_date = new Date(value);
                return new_date.toLocaleString("de-DE", {
                  timeZone: "Europe/Berlin"
                });
              } else {
                return "";
              }
            }
          },
          {
            key: "created_at",
            label: "Created At",
            sortable: true,
            formatter: value => {
              if (value) {
                let new_date = new Date(value);
                return new_date.toLocaleString("de-DE", {
                  timeZone: "Europe/Berlin"
                });
              } else {
                return "";
              }
            }
          },
          { key: "special_instructions", label: "Special Instructions", sortable: true }
        ],
        items: [],
      },
    }
  },
  methods: {
    async getUnfinishedOrders() {
      await axios
        .get(process.env.VUE_APP_ROOT_API + "/unfinished-orders/", {
          headers: {
            "Authorization": `JWT ${this.$store.state.jwt}`,
            "Content-Type": "application/json"
          },
          params: this.queryParams,
        })
        .then(response => {
          this.unfinishedOrdersTable.items = response.data.orders
          this.unfinishedOrdersTable.totalRows = response.data.pagination.results * 2
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$router.push({ name: "login" })
          }
        })
    },
    async handleUnfinishedOrdersPageChange(value) {
      this.showContent = true
      this.queryParams["page"] = value
      await this.getUnfinishedOrders()
      this.showContent = false
    },
    async getMyHubs() {
      await axios
        .get(process.env.VUE_APP_ROOT_API + "/hubs/all/my/", {
          headers: {
            "Authorization": `JWT ${this.$store.state.jwt}`,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          const myHubs = response.data.results.map(item => { return item.name })
          this.hubs = myHubs
          this.selectedHub = myHubs[0]
          this.queryParams["selected_hub"] = this.selectedHub
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$router.push({ name: "login" })
          }
        })
    },
    async changeSelectedHub() {
      this.showContent = true
      this.queryParams["selected_hub"] = this.selectedHub
      this.queryParams["page"] = 1
      this.unfinishedOrdersTable.currentPage = 1
      await this.getUnfinishedOrders()
      this.showContent = false
    }
  },
  async created() {
    this.showContent = true
    Promise.all([
      await this.getMyHubs(),
      await this.getUnfinishedOrders(),
    ]).finally(() => {
      this.showContent = false
    })
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>